jQuery(function($){
    $(document).on('click', '.plus', function(e){
        e.preventDefault();
        var input = $(this).siblings('input');
        var currentValue = parseInt(input.val());
        if (currentValue < input.attr('max')) {
            input.val(currentValue + 1);
            input.trigger('change');
        }
    });
    
    $(document).on('click', '.minus', function(e){
        e.preventDefault();
        var input = $(this).siblings('input');
        var currentValue = parseInt(input.val());
        if (currentValue > input.attr('min')) {
            input.val(currentValue - 1);
            input.trigger('change');
        }
    });
});